export default function About() {
  return (
    <section
    id="about"
      className="w-screen min-h-screen flex items-center justify-center py-8 md:py-0"
      style={{
        background:
          "linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0) 90%), " +
          "linear-gradient(90deg, rgba(103,119,255,0.09) 10%, rgba(195,131,251,0.09) 100%)"
      }}
    >
      <div className="w-11/12 md:w-4/5 mx-auto flex flex-col md:flex-row items-center justify-center gap-8 md:gap-0">
        <div className="flex-1 flex flex-col gap-4 items-center text-center md:items-start md:text-left justify-center px-4 md:px-12 order-1 md:order-2">
          <h2 className="font-medium text-3xl md:text-5xl text-[#121828] mb-2">About</h2>
          <p className="text-base md:text-lg text-[#414653] mb-2">
            XAO DAO is a community-led governance body that gives members a voice in shaping the future of the XRPL ecosystem.
          </p>
          <p className="text-base md:text-lg text-[#414653]">
            It provides a fair and transparent way to make collective decisions, allocate resources, and support innovation.
          </p>
        </div>
        <div className="flex-1 flex items-center justify-center order-2 md:order-1">
          <div className="relative w-[300px] h-[280px] md:w-[514px] md:h-[464px] flex items-center justify-center shadow-lg">
            {/* AboutBg PNG positioned higher and left, dashboard image overlapping */}
            <img
              src="/aboutBg.png"
              alt="About Background"
              className="absolute -top-6 -left-4 md:-top-12 md:-left-8 w-[320px] h-[320px] md:w-[520px] md:h-[520px] object-contain z-0"
              style={{ pointerEvents: "none" }}
            />
            <div className="relative w-full h-full flex items-center justify-center">
              <div className="w-full h-full bg-white rounded-[20px] flex items-center justify-center z-10">
                <img
                  src="./about.png"
                  alt="Dashboard"
                  className="max-w-full max-h-full object-contain rounded-[20px]"
                />
              </div>
              <div className="absolute inset-0 border-2 border-white rounded-[20px] pointer-events-none shadow-[0px_0px_34px_0px_rgba(18,24,40,0.07)] z-20" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}